import React from 'react';
import { Text } from '../Text';
import { SpamTextContainer } from './styles';

export function NoSpamText() {
  const spamText =
    '*We’ll send you a confirmation code to get started — we don’t believe in spam!';

  return (
    <SpamTextContainer data-elementid="no-spam-text">
      <Text fontSize="2xs">{spamText}</Text>
    </SpamTextContainer>
  );
}
